<span class="cp-title-widget-green" style="text-align: center;">{{ literalsCp?.strPedido | uppercase }}</span>

<div class="po-row cp-div-external">
  <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6" style="width: fit-content;">
    <cp-donutchart [value]="taskOrder.percentage" [Kind]="Kind"></cp-donutchart>
  </div>
  <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-div-container">
    <div class="po-row"><span class="cp-info-labels">{{ literalsCp?.strPedido }}</span></div>
    <div class="po-row"><span>{{ taskitem.getFormattedNumber(taskOrder.ordervalue) }}</span></div>
    <br/>
    <div class="po-row"><span class="cp-info-labels">{{ literalsCp?.strEntregue }}</span></div>
    <div class="po-row"><span>{{ taskitem.getFormattedNumber(taskOrder.orderdelivered) }}</span></div>
  </div>
</div>
<div class="po-row np">
  <hr class="cp-div-line np po-xl-12 po-lg-12 po-md-12 po-sm-12" />
</div>
<div class="po-row np cp-div" style="margin-top: 20px;">
  <span class="cp-div-rectangle" style="margin-left: 4px;">
    <span style="font-size: 14px;">{{ literalsCp?.strPago | lowercase}}</span>
  </span>
  <span class="cp-font-bold"
    style="font-size: 14px; margin-left: 8px;">{{ taskitem.getFormattedNumber(taskOrder.orderpaid) }}</span>
</div>

<po-loading-overlay [hidden]="isHideLoading">
</po-loading-overlay>


